import { useMutation } from 'react-query';

import { updateContract } from 'api/endPoints/updateContract';

interface SetTagList {
    contractId: number | undefined;
    tagList: SelectListWithCreateData[];
}

export const useMutationSetTagList = () => {
    return useMutation<any, QueryError, SetTagList>((params) => updateContract(params));
};
